Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.TimeMetricCardView extends Backbone.View
  template: JST['backbone/templates/customer_visual_mode/charts/time_metric/time_metric_card']
  className: 'time-metric-card'

  events:
    'click': '_onClick'

  initialize: ({clickable, value, iconClass, statusClass, title, description=null, dimension}) ->
    @clickable = clickable
    @value = value
    @iconClass = iconClass
    @statusClass = statusClass
    @title = title
    @description = description
    @dimension = dimension

  render: ->
    @$el.html @template
      clickable: @clickable
      value: @_formatSeconds(@value)
      iconClass: @iconClass
      title: @title
      description: @description
    @$el.addClass(@statusClass)
    @$el.addClass('clickable') if @clickable
    @$('.status-icon').html(@_iconView().render().el)
    @

  _onClick: ->
    return unless @clickable
    @trigger('timeMetricCard:click', @dimension)

  _iconView: ->
    new Common.SvgIconView(
      svgPath: 'icons/status-assigned.svg'
      svgId: 'status-assigned'
      iconClass: @iconClass
    )

  _prependDigit: (number) ->
    "#{number}".padStart(2, '0')

  _formatInt: (value) ->
    if !value
      0
    else
      value

  _formatSeconds: (secondsToFormat) ->
    duration = moment.duration(@_formatInt(parseInt(secondsToFormat, 10)), 'seconds')
    hours = parseInt(duration.asHours(), 10)
    minutes = parseInt(duration.minutes(), 10)
    seconds = parseInt(duration.seconds(), 10)
    "#{@_prependDigit(hours)}:#{@_prependDigit(minutes)}:#{@_prependDigit(seconds)}"
